import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from 'utils/services';

import { GetLabRangesReqProps, GetLabRangesResProps } from './labRanges.types';

export const labRangesApi = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    getLabRanges: build.query<GetLabRangesResProps, GetLabRangesReqProps>({
      query: (params) => ({
        params,
        url: '/lab-ranges'
      })
    })
  }),
  reducerPath: 'labRangesApi',
  tagTypes: ['LabRanges']
});
export const { useLazyGetLabRangesQuery } = labRangesApi;
